<template>
  <div class="caibao-wrap">
    <div class="mask" v-show="toggleFlag" @click="closeOptions"></div>
    <div class="index-type-wrap" :style="{borderTop: toggleFlag ? '1px solid #edeff3' : 'none'}">
      <div v-for="(x, index) in tabs" :key="'cateType'+index" class="item" :class="{active:activeTabCur===index}" @click="changeTab(index)">{{x.name}}</div>
      <div class="split"></div>
      <div class="item periods" @click="toggleOptions">{{periodTxt}}<img :src="arrowIcon" class="icon" :class="{revert: toggleFlag}"/></div>
    </div>
    <div class="period-options" v-show="toggleFlag">
      <div class="period-item" :class="{active: item.active}" v-for="(item, index) in periodtabs" :key="item.key" @click="changePeriod(index)">{{item.name}}</div>
    </div>
    <div class="tip-wrap">
      <div>币种：{{currency}}</div>
    </div>
    <div class="con">
      <div v-if="conSelector === null">loading...</div>
      <hs-finance-detail v-if="conSelector === 'CN'" :options="detailOptions" :key="JSON.stringify(detailOptions)"></hs-finance-detail>
      <gmg-finance-detail v-if="conSelector === 'OTHER'" :options="detailOptions" :key="JSON.stringify(detailOptions)" @changeCurrency="changeCurrency"></gmg-finance-detail>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import HsFinanceDetail from './caibaoDetail/hs-finance-detail'
import GmgFinanceDetail from './caibaoDetail/gmg-finance-detail'

const config = {
  CN: [{
    title: '主要指标',
    financetType: 'gjzb'
  },{
    title: '资产负债表',
    financetType: 'fzb'
  },{
    title: '利润表',
    financetType: 'lrb'
  },{
    title: '现金流量表',
    financetType: 'llb'
  }],
  OTHER: [{
    title: '主要指标',
    financetType: 'quota'
  },{
    title: '资产负债表',
    financetType: 'assets'
  },{
    title: '利润表',
    financetType: 'profit'
  },{
    title: '现金流量表',
    financetType: 'cash'
  }]
}

let periodConfig = {
  CN: [
    {name: '全部周期', key: 0, active: true},
    {name: '年报', key: 4},
    {name: '半年报', key: 2},
    {name: '三季报', key: 3},
    {name: '一季报', key: 1}
  ],
  OTHER: [
    {name: '全部周期', key: 'all', active: true},
    {name: '季报', key: 'interim'},
    {name: '年报', key: 'annual'}
  ]
}

export default {
  data() {
    return {
      toggleFlag: false,
      arrowIcon: require('../../../assets/arrow-dark.png'),
      tabs: [
        {name: '主要指标'},
        {name: '负债表'},
        {name: '利润表'},
        {name: '流量表'}
      ],
      activeTabCur: 0,
      activePeriodIndex: 0,
      stock: {},
      detailOptions: {},
      conSelector: null,
      currency: '人民币',
      scrollTop: 0,
      periodtabs: []
    }
  },
  components: {
    HsFinanceDetail,
    GmgFinanceDetail
  },
  computed: {
    ...mapState({
      region: state => state.region
    }),
    periodTxt () {
      return (this.periodtabs[this.activePeriodIndex] && this.periodtabs[this.activePeriodIndex].name) || '全部周期' 
    }
  },
  methods: {
    preventDefault(e) {
      e.preventDefault()
      return false
    },
    closeOptions() {
      document.querySelector('#app').removeEventListener('touchmove', this.preventDefault)
      this.toggleFlag = false
    },
    openOptions() {
      document.body.scrollTop = this.scrollTop
      document.documentElement.scrollTop = this.scrollTop
      document.querySelector('#app').addEventListener('touchmove', this.preventDefault)
      this.toggleFlag = true
    },
    toggleOptions() {
      this.toggleFlag ? this.closeOptions() : this.openOptions()
    },
    getElementTop(element) {
      var actualTop = element.offsetTop
      var current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    changeCurrency(currency) {
      this.currency = currency
    },
    handleDetailOptions() {
      let conf = config[this.conSelector][this.activeTabCur]
      let period = periodConfig[this.conSelector][this.activePeriodIndex]
      this.detailOptions = {
        ...conf,
        ...this.stock,
        ...period
      }
    },
    changeTab(index) {
      this.activeTabCur = index
      this.conSelector = this.region === 'CN' ? 'CN' : 'OTHER'
      this.handleDetailOptions()
    },
    initPeriod() {
      this.periodtabs = periodConfig[this.region === 'CN' ? 'CN' : 'OTHER']
    },
    changePeriod(i) {
      this.periodtabs = this.periodtabs.map((o, index)=> {
        return {
          ...o,
          active: index === i 
        }
      })
      this.activePeriodIndex = i
      this.handleDetailOptions()
      this.closeOptions()
    }
  },
  mounted() {
    this.scrollTop = this.getElementTop(document.querySelector('.index-type-wrap')) - 43 - 50 
  },
  created() {
    this.stock = {
      market: this.$route.params.market.toLowerCase(),
      symbol: this.$route.params.code
    }
    this.initPeriod()
    this.changeTab(0)
  }
}
</script>

<style lang="stylus" scoped>
  .mask
    position fixed
    top 0
    left 0
    bottom 0
    right 0
    z-index 10
    background rgba(0,0,0,0.45)
  .period-options
    position -webkit-sticky
    position sticky
    top 148px
    padding 0 16px
    z-index 101
    background-color #fff
    .period-item
      display flex
      justify-content space-between
      align-items center
      height 48px
      border-top 1px solid #EDEFF3
      font-size 15px
      color #333333
      &.active
        color #F43737
      &.active::after
        content ' '
        display inline-block
        width 16px
        height 12px
        background url('../../../assets/select-arrow.png') no-repeat
        background-size contain
  .index-type-wrap
    position -webkit-sticky
    position sticky
    top 90px
    z-index 101
    display flex
    justify-content space-between
    padding 16px 7px 16px 14px
    background-color #fff
    font-size 14px
    .split
      width 1px
      height 24px
      background-color #EDEFF3
    .periods
      display flex
      align-items center
    .item
      height 26px
      padding 0 5px
      line-height 26px
      border-radius 2px
      &.active
        color #ffffff
        background-color #F43737
    .icon
      width 14px
      height 14px
      margin-left 4px
    .icon.revert
      transform rotate(180deg)
  .tip-wrap
    display flex
    justify-content flex-end
    height 27px
    padding-right 14px
    border-top 1px solid #edeff3
    border-bottom 1px solid #edeff3
    line-height 27px
    color #999999
    font-size 12px
  .tip-wrap-CN
    justify-content space-between
  .tip-wrap-USA,.tip-wrap-HK
    justify-content center
</style>